import React, { useState } from "react";

import { Divider } from '@material-ui/core';

import { ColorPicker, ImageUpload, PackageImport, Select, TitleInput } from '../EditorFormElements';
import { Event } from '.';
import { FormFieldWrapper, SortableList } from "../Global";
import { EditorTabs } from '../Interface';
import { formatOptions,themeColors } from '../../config/timeline';

export const TimelineForm = ({given, ...props}) => {
  const [format,setFormat] = useState('')

  const onFormatChange = (name,value) => setFormat(value);
    
  const generalTab = (
    <>
      <PackageImport />
      
      <FormFieldWrapper>
        <TitleInput 
          label="Item Title"
          defaultText="Enter item title"
          help="Provide a descriptive title to support screen readers. It will act as a header for the section."
          given={given.title}
        />
      </FormFieldWrapper>
    </>
  )

  const stylesTab = (
    <FormFieldWrapper>

      <ColorPicker 
        name="theme"
        label="Color Theme" 
        colors={themeColors}
        given={given.theme}
      />

      <Select
        label="Date Format" 
        name='format' 
        options={formatOptions}
        given={given.format}
        callback={onFormatChange} 
      /> 

      <Divider/>
                
      <ImageUpload 
        label="Background Image" 
        name="bg"
        tooltip="Upload an image to display in the background of the timeline. Image size must be 1920px by 864px and must not exceed 950KB."
        given={given.bg}
        optional
        help="This image is optional."
      />

    </FormFieldWrapper>
  )

  const contentTab = (
    <SortableList
      label="Event"
      name="events"
      given={given.events}
      min={3}
    >
      <Event format={format} />
    </SortableList>
  )

  return (
    <EditorTabs
      general={generalTab}
      styles={stylesTab}
      content={contentTab}
    />
  );
}